import React from 'react';
import './spinner.css';

class Spinner extends React.Component {
    render() {
        return (             
            <div className="spinner-3"></div>
        );
    }
}

export default Spinner;